export default function SectionHeader({ children, left }) {
  return (
    <h3
      className={`${
        left ? "text-left" : "text-center"
      } font-fontOne  mt-12 mb-4 text-3xl font-bold text-[#1A0B5B]`}
    >
      {children}
    </h3>
  );
}
